import { genericCRUDService } from '../../helpers/api';

export const { findAll, downloadAll } = genericCRUDService(
  '/accounts',
  '/api/v1/inspector-last-vehicles',
);
